"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _AddEvent = babelHelpers.interopRequireDefault(require("AddEvent"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _noty = require("noty");

var _class;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var EventPurchaseInfo = (_class =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(EventPurchaseInfo, _Component);

  function EventPurchaseInfo() {
    babelHelpers.classCallCheck(this, EventPurchaseInfo);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(EventPurchaseInfo).apply(this, arguments));
  }

  babelHelpers.createClass(EventPurchaseInfo, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "event-purchase-info"
      }, this.props.password && _react.default.createElement("div", {
        className: "event-password"
      }, "Password: ", _react.default.createElement("span", {
        className: "password"
      }, this.props.password)), _react.default.createElement("p", {
        className: "registered"
      }, this.props.purchaseInfo, this.props.cancelable && _react.default.createElement("br", null), this.props.cancelable && _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.cancelRegistration
      }, "Cancel my registration")), _react.default.createElement(_AddEvent.default, _extends({
        buttonTitle: "Add to Calendar"
      }, this.props)));
    }
  }, {
    key: "cancelRegistration",
    value: function cancelRegistration() {
      if (this.props.cancelable) {
        if (this.props.warnCancel) {
          this.doCancelWarning();
        } else {
          this.doCancel();
        }
      }
    }
  }, {
    key: "doCancelWarning",
    value: function doCancelWarning() {
      alert('FIXME: NOT IMPLEMENTED');
    }
  }, {
    key: "doCancel",
    value: function doCancel() {
      (0, _fetch.default)('purchase/cancel-purchase', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          purchaseId: this.props.purchaseId
        })
      }).then(function (result) {
        return result.json();
      }).then(function (d) {
        (0, _noty.showNotificationText)('Your registration has been cancelled.');
        (0, _userProfile.userProfileUpdated)();
      });
    }
  }]);
  return EventPurchaseInfo;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "cancelRegistration", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "cancelRegistration"), _class.prototype)), _class);
exports.default = EventPurchaseInfo;